import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table } from 'antd';
import ButtonUpload from 'components/Button/ButtonUpload';
import ButtonIcon from 'components/Button/ButtonIcon';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { MSG_TOOLTIP_APAGAR, MSG_NENHUM_ARQUIVO_ENCONTRADO, ALERTA } from 'utils/consts';
import * as S from './styles';
export default function TableSelect({ columns, data, funcAdd, funcDelete, disabled }) {
  const loading = useSelector(state => state.app.statusLoadingGrid);
  const [selectedItems, setSelectedItems] = useState([]);

  const removeItem = () => {
    // AO CLICAR NO BUTTON PARA APAGAR
    // VERIFICA SE EXISTE ITEM SELECIONADO
    // CHAMA A FUNÇÃO PROPS PARA DELETAR
    if (selectedItems?.length > 0) {
      funcDelete(selectedItems);
      setSelectedItems([]);
    } else {
      fetchNotificationApp(MSG_NENHUM_ARQUIVO_ENCONTRADO, '', ALERTA.ERRO);
    }
  };

  const addNewItem = item => {
    // AO CLICAR NO BUTTON PARA ADICIONAR
    // VERIFICA SE EXISTE ITEM
    // CHAMA A FUNÇÃO PROPS PARA ADICIONAR
    if (item) funcAdd(item);
  };

  const rowSelection = {
    // AO CLICAR NO CHECKBOX PARA SELECIONAR UMA LINHA
    // SALVA A LINHA NO STATE
    onChange: (selectedRowKeys, selectedRows) => {
      const itensFiltrados = selectedRows.filter(x => x.key.startsWith('TOTALIZADOR_TEMP') !== true);
      setSelectedItems(itensFiltrados);
    },
    getCheckboxProps: record => {
      if (record.key.startsWith('TOTALIZADOR_TEMP') === true) {
        return { disabled: true };
      }
    },
  };

  const renderButtons = () => {
    // RENDERIZA OS BUTTONS NA PARTE SUPERIOR DA TABELA
    return (
      <S.ContainerButton>
        <ButtonIcon icon="Deletar" clickAction={() => removeItem()} tooltipMessage={MSG_TOOLTIP_APAGAR} />
        <ButtonUpload funcUpload={addNewItem} />
      </S.ContainerButton>
    );
  };

  return (
    <S.ContainerTable id="ComponenteTableSelect">
      {!disabled && renderButtons()}
      <Table
        rowSelection={
          !disabled && {
            type: 'checkbox',
            ...rowSelection,
          }
        }
        columns={columns}
        dataSource={data}
        loading={loading}
      />
    </S.ContainerTable>
  );
}

TableSelect.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  funcAdd: PropTypes.func,
  funcDelete: PropTypes.func,
  disabled: PropTypes.bool,
};

TableSelect.defaultProps = {
  // columns: [],
  // data: null,
  // funcAdd: () => {},
  // funcDelete: () => {},
  // disabled: false,
};
